<div style="padding:20px"> 
    <ul class="nav nav-tabs" style="margin: 10px;">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item">
            <a onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" style="cursor: pointer;"  (click)="choose(item.id)">Menu{{item.name}}</a>
        </li>
    </ul>
    <hr>
   
    <div *ngIf="now=='0'">
        <button class="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg" (click)="defaultData()">點我新增角色</button>
        <div *ngIf="edit_data" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body"> 
                        <div class="wrape_item"  *ngIf="now=='0'">
                            <label class="col-sm-2 col-form-label">角色名稱</label>
                            <input type="text" class="form-control" style="display: inline-block;width: 220px;" [(ngModel)]="edit_role.name" required>    
                        </div>
                        <div class="wrape_item"  *ngIf="now=='0'">
                            <label class="col-sm-2 col-form-label">狀態</label>
                            <button [ngClass]="edit_role.status==1?'btn-danger':'btn-secondary'"  (click)="edit_role.status=1" class="btn modalbtn status">啟用</button>
                            <button [ngClass]="edit_role.status==0?'btn-danger':'btn-secondary'" (click)="edit_role.status=0" class="btn modalbtn status">關閉</button>  
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"  (click)="addRole()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                        <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                    </div>
                </div>
            </div>
        </div>

        <table style="margin-top: 10px;" class="table table-responsive-sm" *ngIf="edit_data.role.length>0" style="margin-top: 6px;">
            <thead>
                <tr class="table-primary" style="font-size:18px;">
                    <th style="width:5%">名稱</th>
                    <th style="width:5%">狀態</th>
                    <th style="width:5%;text-align: center;">MENU權限設定</th>
                    <th style="width:5%;text-align: center;">
                        組件權限
                        <button class="button-71" style="margin-left: 5px;" role="button" data-toggle="modal" data-target="#ComponentModal" (click)="add_component(1)" >設定</button>    
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of edit_data.role; let i = index" [class.table-secondary]="i % 2 === 0" [class.table-light]="i % 2 !== 0">
                    <td>{{item.name}}</td>
                    <td><app-checkswitch [item]="item" [type]='2' (statusChange)="handleStatusChange($event)"></app-checkswitch></td>
                    <td style="text-align: center;">
                        <button class="button-99" role="button" data-toggle="modal" data-target="#yourModal" (click)="getRoleMenu(item.id)">設定</button>
                    </td>
                    <td style="text-align: center;">
                        <button class="button-72" role="button" data-toggle="modal" data-target="#ComponentModalList" (click)="getRoleComponent(item.id)">查看</button>
                    </td>
                </tr>
                <div class="modal fade" id="yourModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"  data-backdrop="static" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">MENU 權限設定</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <thead>
                                    <tr class="table-primary" style="font-size:18px;">
                                        <th style="width:5%">名稱</th>
                                        <th style="width:5%">權限開關</th>
                                    </tr>
                                    <tr *ngFor="let Mitem of role_menu; let i = index" [ngClass]="{'table-secondary': (i % 2 === 0 && Mitem.uid > 0), 'table-light': (i % 2 !== 0  && Mitem.uid > 0), 'table-top': Mitem.uid == 0}" [ngStyle]="{'font-size': Mitem.uid == 0 ? '27px' : 'inherit', 'text-align': Mitem.uid == 0 ? 'center' : 'inherit', 'font-weight': Mitem.uid == 0 ? 'bolder' : 'inherit' }">
                                        <td>{{Mitem.name}}</td>
                                        <td>
                                            <button [ngClass]="Mitem.status==1?'btn-warning':'btn-secondary'"  (click)="role_menu[i].status=1;allchange(Mitem);" class="btn modalbtn status">啟用</button>
                                            <button [ngClass]="Mitem.status==0?'btn-warning':'btn-secondary'" (click)="role_menu[i].status=0;allchange(Mitem);" class="btn modalbtn status">關閉</button>  
                                        </td>
                                    </tr>
                                </thead>                        
                            </div>
                            
                            <div class="modal-footer">
                                <button type="button"  (click)="changeMenuPower(role_id)"  class="btn btn-primary" data-dismiss="modal">確認</button>
                                <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="ComponentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"  data-backdrop="static" aria-hidden="true">
                    
                    <div class="modal-dialog  modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">組件權限設定</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <thead>
                                    <div class="wrape_item">
                                        <button type="button" style="margin-left: 10px;margin-bottom: 5px;" (click)="add_component(2)" class="btn btn-primary">新增組件</button>
                                    </div>
                                    <tr class="table-primary" style="font-size:18px;" *ngIf="componentpower">
                                        <th style="width:5%">組件名稱</th>
                                        <th style="width:5%">適用MENU</th>
                                        <th style="width:5%">角色限制</th>
                                        <th style="width:5%">備註</th>
                                    </tr>
                                    <tr *ngFor="let power of componentpower; let i = index">
                                        <th style="width:5%">
                                            <p> {{power.name}}</p>
                                        </th>
                                        <th style="width:5%">                                         
                                            <mat-form-field>
                                                <mat-label>Menu選單</mat-label>
                                                <mat-select [(value)]="selectedMenuValue[i]">
                                                    <mat-option *ngFor="let item of menu_name" [value]="item.id">
                                                        {{item.item}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </th>
                                        <th style="width:5%">
                                            <mat-form-field>
                                                <mat-label>選擇限制的角色</mat-label>
                                                <mat-select [(value)]="selectedOptions[i]" multiple>
                                                    <mat-option *ngFor="let item of edit_data.role" [value]="item.id">{{ item.name }}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </th>
                                        <th style="width:5%">
                                            <mat-form-field class="example-full-width">
                                                <mat-label>輸入備註</mat-label>
                                                <textarea matInput placeholder="此處輸入備註" [(ngModel)]="texteria[i]"></textarea>
                                            </mat-form-field>
                                        </th>
                                    </tr>
                                </thead>    
                            </div>
                            <div class="modal-footer">
                                <button type="button"  (click)="changeComponentPower()"  class="btn btn-primary" data-dismiss="modal">確認</button>
                                <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="ComponentModalList" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"  data-backdrop="static" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">組件權限查看</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <thead>
                                    <tr class="table-primary" style="font-size:18px;">
                                        <th style="width:5%">組件名稱</th>
                                        <th style="width:5%">適用MENU</th>
                                    </tr>
                                    <tr *ngFor="let role of roleComponent; let i = index" style="font-size:18px;">
                                        <th style="width:5%">{{role.name}}</th>
                                        <th style="width:5%">{{role.item}}</th>
                                    </tr>
                                </thead>                        
                            </div>
                            
                            <div class="modal-footer">
                                <button type="button"  (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">關閉</button>
                            </div>
                        </div>
                    </div>
                </div>

            </tbody>
            
        </table>
        <div *ngIf="edit_data.role.length==0">無資料</div>
    </div>
    <div *ngIf="now == '1'">
        <div class="main-menu-container">
            <button id="restoreButton" (click)="restart()">還原預設值</button>
            <h2>MENU選單</h2>
            <div style="display: flex;">
                <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                    <div class="example-box" *ngFor="let item of mainMenu" cdkDrag (click)="submain(item.id)">{{item.item}}</div>
                </div>
                <div cdkDropList class="example-list" (cdkDropListDropped)="dropsub($event)" *ngIf="submainNum > 0" style="margin-left: 5%;">
                    <div class="example-box" *ngFor="let item of subMenu" cdkDrag>{{item.item}}</div>
                </div>
            </div>   
            
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
<app-toast></app-toast>
